module.exports = __webpack_public_path__ + "img/trash.262d23a7.svg";